var React = require( 'react' );
var createReactClass = require('create-react-class');
var Link = require('react-router').Link;
var PureRenderMixin = require('react-addons-pure-render-mixin');
var FBLoginButtonWrapper = require('./fbLoginButtonWrapper.jsx');

var LoginBox = createReactClass({
	mixins: [PureRenderMixin],

    handleBasicLogin: function(event) {
    	event.preventDefault();
    	var email = this.refs.email.value.trim().toLowerCase();
    	var password = this.refs.password.value;
    	this.props.login(email, password, this.props.loginRedirectUrl, this.props.analyticsLabelSuffix);
    },

    handleClickTracking: function(event){
        var target = event.target;
        var label = target.innerText + (this.props.analyticsLabelSuffix ? ' ' + this.props.analyticsLabelSuffix : '');
        var action = 'Click';

        if(label === 'Login'){
            action = 'Submit';
            label = 'Email' + (this.props.analyticsLabelSuffix ? ' ' + this.props.analyticsLabelSuffix : '');
        }

        this.props.recordLoginClick(action, label);
    },

    handleRegisterEntryClick: function(event){
        event.preventDefault();
        this.handleClickTracking(event);
        this.props.clearLoginError();
        this.props.showModal('MODAL_TYPE_REGISTER');
    },

    render: function(){
        var errorMsg = this.props.auth && Object.keys(this.props.auth.error).length > 0 && (this.props.auth.error.error_description ? this.props.auth.error.error_description : this.props.auth.error.toString());

        return (
            <div className="special-form-box-wrapper">
                <div className="login-box special-form-box">
					<h1 className="hide-for-large">Login</h1>
                    <div className="form">
                        {this.props.authFacebook &&
                            <FBLoginButtonWrapper
                                authFacebook={this.props.authFacebook}
                                loginRedirectUrl={this.props.loginRedirectUrl}
                                source={this.props.source}
                                clickTracking={this.props.recordLoginClick} />
                        }
                        <form onSubmit={this.handleBasicLogin} noValidate>
							<div className="input-field-wrapper">
								<div className="input-field">
	                                <label className="heading" htmlFor="email">Email</label>
	                                <input type="email" name="email" id="email" ref="email" placeholder="john@example.com" required />
	                            </div>
	                            <div className="input-field">
	                                <label className="heading" htmlFor="password">Password</label>
	                                <input type="password" name="password" id="password" ref="password" autoComplete="off" required />
	                            </div>
							</div>

							<button className="button success" type="submit" onClick={this.handleClickTracking}>Login into Account</button>
                            {errorMsg && <p className="error-msg">{errorMsg}</p>}
                        </form>
                        <p className="register-entry-wrapper show-for-reveal">Don't have an account already? <Link to="/register" onClick={this.handleRegisterEntryClick}>Sign Up</Link></p>
                    </div>
                </div>
                <div className="special-form-box-suffix margin-top-small margin-bottom-large clearfix">
                    <p className="float-right"><Link to="/password-reset" onClick={this.handleClickTracking}>Forgot password?</Link></p>
                    <p className="float-left">New to MyGiHealth? <Link to="/register" onClick={this.handleClickTracking}>Create an Account</Link></p>
                </div>
            </div>
        )
    }
});

module.exports = LoginBox;



// WEBPACK FOOTER //
// ./src/common/routes/components/loginBox.jsx